



import { Vue, Component, Prop } from "vue-property-decorator";
import echart from "echarts";

@Component({
  components: {},
})
export default class PiePercentView extends Vue {
  @Prop()
  public name!: string;
  @Prop()
  public height!: Number;

  @Prop()
  public percent!: number;

  @Prop()
  public label!: string;

  @Prop()
  public secondLineLabel?: string;

  @Prop()
  public color!: Array<string>;

  public mychart: any;

  public draw() {
    let dom = document.getElementById(this.name) as any;
    const width: string = window
      .getComputedStyle(dom)
      .width.replaceAll("px", "");
    const valueFontSize = parseFloat(width) / 5;
    const nameFontSize = parseFloat(width) / 11;
    let formatter = "{value|{c}}{mark|%}\n\n{name|{b}}";
   
    if (this.secondLineLabel) {
      formatter = "\n{value|{c}}{mark|%}\n\n{name|{b}}" + "\n{secondLine|" + this.secondLineLabel + "}";
    }
    let option = {
      color: this.color,
      series: [
        {
          type: "pie",
          legendHoverLink: false,
          hoverAnimation: false,
          radius: ["80%", "100%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center",
            formatter: formatter,
            rich: {
              value: {
                fontSize: valueFontSize,
                color: this.color[0],
              },
              mark: {
                fontSize: valueFontSize,
                color: this.color[0],
              },
              name: {
                color: this.color[0],
                fontSize: nameFontSize,
                fontWeight: 600,
              },
              secondLine: {
                color: this.color[0],
                fontSize: nameFontSize,
                fontWeight: 600,
              },
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: this.percent, name: this.label, label: { show: true } },
            { value: 100 - this.percent },
          ],
        },
      ],
    };
    this.mychart.setOption(option);
  }

  mounted() {
    let dom = document.getElementById(this.name) as any;
    dom.style.height = this.height + "px";
    this.mychart = echart.init(dom);
    
    setTimeout(() => {
       this.draw();
      this.mychart.resize();
    }, 100);
    window.addEventListener("resize", () => {
      this.draw();
      this.mychart.resize();
    });
    const tempThis = this as any;

    if (tempThis.$bus) {
      tempThis.$bus.$on("collapseChange", () => {
        setTimeout(() => {
          this.draw();
          this.mychart.resize();
        }, 300);
      });
    }
  }
}
